/**
 * HUSL storefront env — pick API host from storefront hostname / shop domain.
 * Staging → api-staging.huslbeauty.com
 * Prod → api.huslbeauty.com
 * Safe to promote the same theme code staging → prod.
 */
(function (global) {
  var STAGING_SHOP = 'y0pv0t-qs.myshopify.com';
  var STAGING_API = 'api-staging.huslbeauty.com';
  var PROD_API = 'api.huslbeauty.com';

  function isStagingHost(host) {
    host = String(host || '').toLowerCase();
    if (!host) return false;
    if (host === 'localhost' || host === '127.0.0.1') return true;
    if (host.indexOf('staging.') === 0) return true;
    if (host === 'staging.huslbeauty.com') return true;
    if (host === STAGING_SHOP) return true;
    return false;
  }

  function currentHost() {
    if (global.location && global.location.hostname) {
      return global.location.hostname;
    }
    return '';
  }

  function shopDomain() {
    return String(global.__HUSL_SHOP_DOMAIN__ || '').toLowerCase();
  }

  function isStaging() {
    return isStagingHost(currentHost()) || isStagingHost(shopDomain());
  }

  function apiHost() {
    return isStaging() ? STAGING_API : PROD_API;
  }

  function apiBase() {
    return 'https://' + apiHost();
  }

  /**
   * JSON headers plus the logged-in customer's signed token (rendered by layout/theme.liquid).
   * Every HUSL API call that reads or changes a customer's data must send these.
   */
  function customerHeaders() {
    var headers = { 'Content-Type': 'application/json' };
    if (global.HuslCustomer && global.HuslCustomer.token) {
      headers['X-HUSL-Customer-Token'] = global.HuslCustomer.token;
    }
    return headers;
  }

  global.HuslEnv = {
    isStaging: isStaging,
    apiHost: apiHost,
    apiBase: apiBase,
    customerHeaders: customerHeaders,
    STAGING_API: STAGING_API,
    PROD_API: PROD_API,
  };
})(typeof window !== 'undefined' ? window : this);
